<div class="abas-forma-envio">
  <button type="button"
          class="aba aba-whatsapp"
          [class.aba-ativa]="tipoDisparoEscolhido.Whatsapp"
          [disabled]="listaDisabled.Whatsapp"
          (click)="selecionarTipo('Whatsapp')">
    <span class="aba-icone"></span>
    <span class="aba-label">Whatsapp</span>
  </button>

  <button type="button"
          class="aba aba-email"
          [class.aba-ativa]="tipoDisparoEscolhido.Email"
          [disabled]="listaDisabled.Email"
          (click)="selecionarTipo('Email')">
    <span class="aba-icone"></span>
    <span class="aba-label">E-mail</span>
  </button>

  <button type="button"
          class="aba aba-sms"
          [class.aba-ativa]="tipoDisparoEscolhido.sms"
          [disabled]="listaDisabled.sms"
          (click)="selecionarTipo('sms')">
    <span class="aba-icone"></span>
    <span class="aba-label">SMS</span>
  </button>
</div>
